import React from 'react';
import { useStyles } from '../../helper';
import Dialog from '@material-ui/core/Dialog';

const PhotoSlider = ({openModal, setOpenModal}) => {
    const classes = useStyles()
    return (
        <Dialog onClose={() => setOpenModal('')} open={openModal !== ''}>
            <div>
                <img src={openModal} alt="logo" className={classes.dialogImage}/>
            </div>
        </Dialog>
    )
}

export default PhotoSlider;